export const VTMN_CHIP_VARIANT = {
  SINGLE_CHOICE: 'single-choice',
  INPUT: 'input',
  FILTER: 'filter',
  ACTION: 'action',
};

export const VTMN_CHIP_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
